import { Anchor, Box, Button, Card, CardBody, CardHeader, Heading, Text, Paragraph } from 'grommet'
import { Alert, CircleQuestion, FormClose, ShareRounded } from 'grommet-icons'
import PropTypes from 'prop-types'
import React, { Component, useState, useEffect } from 'react'
import { MotionBox, MotionCard } from './Motion'
import { AnimatePresence } from 'framer-motion'
import { RoundIconButton } from './Common'

export const ErrorCard = ({ name, message, detail, closeAction, logoutAction, type }) => {
  // what support types to show a contact support message on?
  const supportTypes = ['unknown_error', 'network_error', 'support_required']
  const allowSupport = type ? supportTypes.indexOf(type) > -1 : false
  // allow a login button, only needed if authorization expires.
  const allowLogout =
    detail &&
    (detail.toLowerCase().startsWith('authorization expired') ||
      detail.toLowerCase().startsWith('client access is restricted'))

  return (
    <Card flex={'grow'} elevation={'xlarge'} background={'white'}>
      <CardHeader
        height={{ min: 'xxsmall' }}
        pad={{ horizontal: 'small', vertical: 'xsmall' }}
        border={{ side: 'bottom', color: 'light-3' }}
      >
        <Heading level={4} margin={'none'}>
          {name ? name : 'Something went wrong'}
        </Heading>
        {!allowLogout && <RoundIconButton Icon={FormClose} onClick={() => closeAction()} />}
      </CardHeader>
      <CardBody fill justify="center" align={'center'}>
        <Box pad={'medium'}>
          <Alert size={'xlarge'} color={'light-6'} />
        </Box>
        <Box
          width={{ max: 'medium-medium' }}
          round="small"
          pad="medium"
          margin={'medium'}
          gap={'large'}
          justify="center"
          align={'center'}
          // border={{ color: 'status-critical' }}
        >
          {message && (
            <Text weight={'bold'} size={'large'} color={'status-critical'}>
              {message}
            </Text>
          )}

          {detail && (
            <Text weight="bold" size={'large'} color={'status-critical'}>
              {detail}
            </Text>
          )}

          {allowSupport && (
            <Text>
              If this problem persists. Please contact{' '}
              <Anchor
                // color={'status-critical'}
                label="support@foodmesh.ca"
                href={'mailto:support@foodmesh.ca'}
                target={'_blank'}
              />{' '}
              with a screenshot of this message.
            </Text>
          )}
        </Box>

        {allowLogout && logoutAction && (
          <Box pad={'medium'}>
            <Button size={'large'} color={'brand'} primary label="Login" onClick={logoutAction} />
          </Box>
        )}
      </CardBody>
    </Card>
  )
}
ErrorCard.propTypes = {
  name: PropTypes.string,
  message: PropTypes.string,
  closeAction: PropTypes.func
}
export const PageCard = ({
  heading,
  children,
  iconButtons = [],
  closeAction,
  show = false,
  motionProps = {},
  headerProps = {},
  CloseIcon,
  ...rest
}) => {
  return (
    <AnimatePresence inital={true}>
      {show && (
        <MotionBox
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
          transition={{ type: 'spring', duration: 0.7 }}
          fill
          {...motionProps}
          {...rest}
        >
          {(heading || closeAction) && (
            <CardHeader
              pad={{ left: 'medium', right: 'xxsmall', vertical: 'xxsmall' }}
              border={{ side: 'bottom' }}
              {...headerProps}
            >
              {heading && typeof heading === 'string' ? (
                <Heading level={5} margin={'none'}>
                  {heading}
                </Heading>
              ) : (
                heading
              )}
              {iconButtons.map((item, index) => (
                <Button
                  key={index}
                  hoverIndicator
                  color={headerProps.background || 'transparent'}
                  plain={false}
                  primary
                  {...item}
                />
              ))}
              {closeAction && (
                <Button
                  icon={CloseIcon ? <CloseIcon size={'medium'} /> :<FormClose />}
                  onClick={() => closeAction()}
                  hoverIndicator
                  color={headerProps.background || 'transparent'}
                  plain={false}
                  primary
                />
              )}
            </CardHeader>
          )}
          <CardBody>{children}</CardBody>
        </MotionBox>
      )}
    </AnimatePresence>
  )
}
PageCard.propTypes = {
  closeAction: PropTypes.func
}

export const SupportIconCard = ({
  heading = '',
  show = true,
  closeAction,
  SupportIcon = CircleQuestion,
  supportText,
  supportEmail = 'support@foodmesh.ca'
}) => (
  <PageCard
    // width={'medium'}
    background={'white'}
    show={show}
    round={'small'}
    elevation={'xlarge'}
    heading={heading}
    closeAction={closeAction}
  >
    <Box pad={'large'} fill align={'center'} justify={'center'} gap={'small'}>
      <Box pad={{ bottom: 'medium' }}>
        <SupportIcon size={'xlarge'} color={'light-6'} />
      </Box>
      {supportText && <Text size={'large'}>{supportText}</Text>}
      <Text>
        Contact <Anchor label={supportEmail} href={'mailto:' + supportEmail} />
      </Text>
    </Box>
  </PageCard>
)
